//请自行添加语言资源
const create = {
  creatorUserName: '创建人',
  orderDate: '创建日期',
  customerCode: '客户名称',
  consigneeCode: '收货方',
  consigneeAddrCode: '客户地址',
  contactInformation: '联系方式',
  contacts: '联系人',
  expectedDeliveryDate: '预约提货日期',
  orderTypeCode: '订单类型',
  remark: '备注',
  skuType: '箱型',
  grossWeight: '重量',
  length:'长',
  width: '宽',
  height:'高(折叠后)',
  skuSaleMinQty: '最小起订量',
  skuQty: '需求数量',
  productName: '产品名称',
  number: '数量',
  msg:{
    customerCode: '请选择客户',
    consigneeCode: '请选择收货方',
    consigneeAddrCode: '请选择收货地址',
    contacts: '请填写联系人',
    contactInformation: '请选择联系方式',
    orderTypeCode: '请选择订单类型',
    expectedDeliveryDate: '请选择预约提货日期',
    number: '请填写数量'
  }
};
export default create



// WEBPACK FOOTER //
// ./src/page/recovery/create/lang/recoveryCreate.zh.js